<template functional>
    <div>
        <translate path="Cancellation.unknown.text" tag="p"/>

        <translate path="Cancellation.contact" tag="p">
            <template v-slot:phone>
                <strong>{{props.supportPhone}}</strong>
            </template>
            <template v-slot:email>
                <strong>{{props.supportEmail}}</strong>
            </template>
        </translate>

        <div class="text-center">
            <button class="btn btn-primary text text-uppercase" @click="listeners.back">
                {{parent.$t('Generic.goback')}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UnknownVoucherCode',
        props: {
            supportPhone: String,
            supportEmail: String
        }
    }
</script>

